define('gusto-core', [],function () {
    "use strict";

    if (!window.gusto) {
        window.gusto = {};
    }
    return window.gusto;
});

